import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowNortheast16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M13 3H5v1.5h5.44l-7.97 7.97 1.06 1.06 7.97-7.97V11H13z"
	})
});
const ForwardRef = forwardRef(SvgIconArrowNortheast16);
export default ForwardRef;
